import React from "react";
import { Row, Col, Form, Space, Typography } from "antd";

import styles from "./styles/ManageTREPage.module.css";
import AppContainer from "../../components/AppContainer/AppContainer";
import { useLocation } from "react-router-dom";
const { Paragraph } = Typography;

function ManageTREPageDetails() {
  const location = useLocation().state;

  const locationData = location
    ? {
        ...location,
        barangay: location?.barangayCode,
        municipality: location?.municipalityCode,
        province: location?.provinceCode,
        region: location?.regionCode,
      }
    : null;


  return (
    <AppContainer title="TRE ACCOUNTS DETAILS">
      <div style={{ margin: "20px 0px", width: "80vw" }}>
        <center>
          <div className={styles.content}>
            <div className={styles.info}>
              <Form>
                <Space
                  direction="vertical"
                  size={"middle"}
                  style={{ width: "100%" }}
                >
                  <div className={styles.info}>
                    <Row gutter={10}>
                      <Col span={8}>
                        <Paragraph
                          strong
                          style={{ textAlign: "left" }}
                          ellipsis
                        >
                          Category:
                        </Paragraph>
                      </Col>
                      <Col span={8}>
                        <Paragraph style={{ textAlign: "left" }}>
                          {locationData.category}
                        </Paragraph>
                      </Col>
                    </Row>

                    <Row gutter={10}>
                      <Col span={8}>
                        <Paragraph
                          strong
                          style={{ textAlign: "left" }}
                          ellipsis
                        >
                          TRE Name:
                        </Paragraph>
                      </Col>
                      <Col span={8}>
                        <Paragraph style={{ textAlign: "left" }}>
                          {locationData.name}
                        </Paragraph>
                      </Col>
                    </Row>

                    <Row gutter={10}>
                      <Col span={8}>
                        <Paragraph
                          strong
                          style={{ textAlign: "left" }}
                          ellipsis
                        >
                          Street of the business:
                        </Paragraph>
                      </Col>
                      <Col span={10}>
                        <Paragraph style={{ textAlign: "left" }}>
                          {locationData.street}
                        </Paragraph>
                      </Col>
                    </Row>

                    <Row gutter={10}>
                      <Col span={8}>
                        <Paragraph
                          strong
                          style={{ textAlign: "left" }}
                          ellipsis
                        >
                          Address:
                        </Paragraph>
                      </Col>
                      <Col span={10}>
                        <Paragraph style={{ textAlign: "left" }}>
                          {locationData.street}
                          {", "}
                          {locationData.address}
                          {", "}
                          {locationData.zipCode}
                        </Paragraph>
                      </Col>
                    </Row>

                    <Row gutter={10}>
                      <Col span={8}>
                        <Paragraph
                          strong
                          style={{ textAlign: "left" }}
                          ellipsis
                        >
                          No. of Available Rooms:
                        </Paragraph>
                      </Col>
                      <Col span={10}>
                        <Paragraph style={{ textAlign: "left" }}>
                          {locationData.noAvailableROoms}
                        </Paragraph>
                      </Col>
                    </Row>

                    <Row gutter={10}>
                      <Col span={8}>
                        <Paragraph
                          strong
                          style={{ textAlign: "left" }}
                          ellipsis
                        >
                          Holding Capacity:
                        </Paragraph>
                      </Col>
                      <Col span={10}>
                        <Paragraph style={{ textAlign: "left" }}>
                          {locationData.holdingCapacity}
                        </Paragraph>
                      </Col>
                    </Row>

                    <Row gutter={10}>
                      <Col span={8}>
                        <Paragraph
                          strong
                          style={{ textAlign: "left" }}
                          ellipsis
                        >
                          Attraction Code:
                        </Paragraph>
                      </Col>
                      <Col span={10}>
                        <Paragraph style={{ textAlign: "left" }}>
                          {locationData.attractionCode}
                        </Paragraph>
                      </Col>
                    </Row>
                  </div>
                </Space>
              </Form>
            </div>
          </div>
        </center>
      </div>
    </AppContainer>
  );
}

export default ManageTREPageDetails;
